//NEW: UI_REVAMP
import { Flex, Grid, Text } from '@chakra-ui/react';
import { DIGITS } from '../../../constant/bet1';
import Bet1Button from './Bet1Button';

const BetOne2DKeypad = ({ selection = [[], [], [], []], onDigitClick, isDisabled }) => {
	const groups = [selection.slice(0, 2), selection.slice(2, 4)];
	const titles = ['SET 01', 'SET 02'];

	return (
		<Grid templateColumns='repeat(2, 1fr)' gap={2} w='full' h='full'>
			{groups.map((group, groupIdx) => (
				<Flex
					key={groupIdx}
					bg={{ base: 'none', lg: 'rgba(255, 255, 255, 0.30)' }}
					borderRadius='12px'
					p={{ base: 0, lg: 2 }}
					direction='column'
					h='full'
				>
					{/* Title */}
					<Flex justify='center' mb={{ base: 0, lg: 2 }}>
						<Text fontWeight={600} fontSize='14px'>
							{titles[groupIdx]}
						</Text>
					</Flex>

					{/* Columns */}
					<Grid
						templateColumns='repeat(2, 1fr)'
						gap={3}
						flex='1'
						bg={{ base: 'rgba(255, 255, 255, 0.30)', lg: 'none' }}
						boxShadow={{ base: '0 0 4px 0 #8674FE', lg: 'none' }}
						borderRadius='12px'
						py={1}
						px={4}
					>
						{group.map((colSelection, colIdx) => {
							const actualColIdx = groupIdx * 2 + colIdx;

							return (
								<Grid
									key={actualColIdx}
									templateRows='repeat(10, 1fr)'
									gap={2}
									justifyItems='center'
									alignItems='center'
									h='full'
								>
									{DIGITS.map((digit) => {
										const isSelected = colSelection.includes(digit.toString());

										return (
											<Bet1Button
												key={digit}
												digit={digit}
												isSelected={isSelected}
												onDigitClick={onDigitClick}
												actualColIdx={actualColIdx}
												colIdx={colIdx}
												isDisabled={(colIdx === 0 && parseInt(digit) > 3) || isDisabled}
											/>
										);
									})}
								</Grid>
							);
						})}
					</Grid>
				</Flex>
			))}
		</Grid>
	);
};

export default BetOne2DKeypad;
